import React, { Component } from 'react';
import { connect } from "react-redux";
import {getBarWidth} from './getBarWidth.js';
import {DEFAULT_RESOLUTION} from './constants.js';

const SCROLL_BUFFER_LENGTH = 100;
const INFO_WIDTH = 0;

class ClockTickComponent extends Component {
    constructor(props) {
        super(props);

        this.unlockedScroll = false;

        this.unlockScroll = this.unlockScroll.bind(this);
    }

    unlockScroll() {
        this.unlockedScroll = true;
    }

    componentDidMount() {
        window.addEventListener('mousewheel', this.unlockScroll);
        this.arrangementContainer = document.getElementsByClassName('arrangement-container')[0];
    }

    componentWillUnmount() {
        window.removeEventListener('mousewheel', this.unlockScroll);
    }

    getX(props=this.props) {
        let cursorStep = props.sequencerEngine.state.arrangement.cursorStep;
        let step = props.isPlaying ? props.step : cursorStep;
        let width = getBarWidth(step, props.resolution, props.xScale);
        return width;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isPlaying !== this.props.isPlaying &&
            prevProps.isPlaying) {
            this.unlockedScroll=false;
        }
        let scroll = this.arrangementContainer ? this.arrangementContainer.scrollLeft : 0;

        if (prevProps.step !== this.props.step) { // || prevProps.xScale !== this.props.xScale) {
            let x = this.getX();
            if (!this.props.isPlaying && (x > window.innerWidth - 400 || x < scroll)) {
                // this.arrangementContainer.scrollLeft = x - this.props.mouseDownX + 100;
            } else if (x > window.innerWidth - 400 ||
                      x < scroll ||
                      !this.props.resolution.equals(this.props.resolution)) {
                if (!this.unlockedScroll) {
                    // todo: check for redux variable forcing scroll
                    return;
                    let scrollLeft = x - SCROLL_BUFFER_LENGTH;
                    this.arrangementContainer.scrollLeft = scrollLeft;
                    this.unlockedScroll = false;
                }
            }
        }
        return true;
    }

    render() {
        let style =  {
            left: this.getX()
        };

        if (!this.props.isPlaying) {
            style.display = 'none';
        }
        return (
            <div
              style={style}
              className="clock-ticker">
            </div>
        );
    }
}

const mapStateToProps = state => {
    let id = state.sequencer.sequencerEngine.getSequenceId();
    let isPlaying = state.sequencer.isPlaying[id] || 0;
    return {
        step: isPlaying ? state.sequencer.sequencerEngine.trackStep : 0,
        cursorStep: state.arrangement.cursorStep,
        mouseDownX: state.arrangement.mouseDownX,
        resolution: DEFAULT_RESOLUTION,
        isRecordingMix: state.mix.isRecordingMix,
        isPlaying: isPlaying,
        xScale: state.arrangement.xScale
    };
};
 
export default connect(mapStateToProps, null)(ClockTickComponent);

